<template>
  <div class="base-settings">
    <mk-tabs-biz
      v-model="activeName"
      class="el-tabs-mk-ui"
    >
      <mk-tab-pane
        v-for="(item, index) in tabs"
        :key="index"
        :label="item.label"
        :name="item.name"
      >
      </mk-tab-pane>
    </mk-tabs-biz>
    <div class="tab-main-info">
      <component :is="activeName"></component>
    </div>
  </div>
</template>

<script>
import TagsSettings from './components/tags-settings'
import AuthSettings from './components/auth-settings'
import ShareSettings from './components/share-settings'
export default {
  name: 'BaseSettings',
  components: {
    TagsSettings,
    AuthSettings,
    ShareSettings
  },
  data () {
    return {
      activeName: 'tags-settings',
      tabs: [{
        label: '标签设置',
        name: 'tags-settings'
      },
      {
        label: '分享设置',
        name: 'share-settings'
      },
      {
        label: '权限设置',
        name: 'auth-settings'
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
.base-settings {
  height: 100%;
  display: flex;
  flex-direction: column;

  .tab-main-info {
    height: 100%;
  }
}
</style>
